import { defineStore } from "pinia"
import { inject, ref } from "vue"
import { useFetchWrapper } from "@core/composables"
import type { Services } from "@services"
import type { OptimTurpeDashboardWorkflowAnalysesResponse } from "@modules/courtage/types/optim-turpe-dashboard"

export const useOptimTurpeDashboardStore = defineStore(
    "optimTurpeDashboard",
    () => {
        const services = inject<Services>("services")

        const synthesis =
            ref<OptimTurpeDashboardWorkflowAnalysesResponse | null>(null)
        const fetchErrorMessage = ref<string | null>(null)

        const {
            fetch: fetchDashboardRaw,
            isFetching: isFetchingDashboard,
            error: fetchDashboardError,
        } = useFetchWrapper(
            async (_kwargs: unknown, controller?: AbortController) => {
                fetchErrorMessage.value = null
                if (!services?.$getOptimDashboard) {
                    fetchErrorMessage.value = "Service indisponible"
                    return
                }
                synthesis.value = await services.$getOptimDashboard(controller)
            }
        )

        /**
         * Charge la synthèse dashboard parc.
         */
        async function fetchDashboard(): Promise<void> {
            await fetchDashboardRaw()
            if (fetchDashboardError.value) {
                fetchErrorMessage.value =
                    fetchDashboardError.value.message ||
                    "Impossible de charger la synthèse optimisation contractuelle."
            }
        }

        /**
         * Réinitialise l’état (ex. sortie de page).
         */
        function resetDashboard(): void {
            synthesis.value = null
            fetchErrorMessage.value = null
        }

        return {
            synthesis,
            fetchErrorMessage,
            isFetchingDashboard,
            fetchDashboard,
            resetDashboard,
        }
    }
)
